import {reqWithToken} from './requestHelper';

//crud

export async function insert(insert) {
    return (await reqWithToken('api/german',{
        method: 'post',
        data: insert
    })).data;
}

export async function getstud() {

    return (await reqWithToken('api/german/studentdata')).data;
}

export async function get(id) {
    return (await reqWithToken(`api/german/${id}`,)).data;
}



export async function getAll() {
    return (await reqWithToken('api/german')).data;
}

export async function getstudentAll() {
    return (await reqWithToken('api/german/getstudentAll')).data;
}


export async function update(update) {
    return (await reqWithToken('api/german',{
        method: 'put',
        data: update
    })).data;
}

export async function remove(id) {
    return (await reqWithToken('api/german/',{
        method: 'delete',
        params: {id}
    })).data;
}

export async function getFormActionByInfo(update) {
    return (await reqWithToken('api/german/getFormActionByInfo',{
        method: 'put',
        data: update
    })).data;
}